module.exports = __webpack_public_path__ + "img/buy-btn.a58579ea.png";